import { createSlice } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  adminList: [],
  totalAdmin: 0,
  totalSuperAdminCount : 0,
  totalAdminCount: 0,
  activeCount: 0,
  blockedCount: 0,
  activeRoleList: [],
  totalActiveRole: 0,
  detailsLoading: false,
  adminDetails: null,
};

const slice = createSlice({
  name: "admin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get Admin List
    builder.addCase(Act.adminApi.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(Act.adminApi.fulfilled, (state, action) => {
      state.adminList = action.payload.data;
      state.totalAdmin = action.payload.totalcount;
      state.totalSuperAdminCount = action.payload.totalSuperAdminCount;
      state.totalAdminCount = action.payload.totalAdminCount;
      state.activeCount = action.payload.activeCount;
      state.blockedCount = action.payload.blockedCount;
      state.loading = false;
    });

    builder.addCase(Act.adminApi.rejected, (state) => {
      state.loading = false;
    });

    // Add Admin
    builder.addCase(Act.addAdminApi.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(Act.addAdminApi.fulfilled, (state, action) => {
      state.adminList = [action.payload.data, ...state.adminList];
      state.totalAdmin += 1;
      state.loading = false;
    });

    builder.addCase(Act.addAdminApi.rejected, (state) => {
      state.loading = false;
    });

    // Update Admin
    builder.addCase(Act.updateAdminApi.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(Act.updateAdminApi.fulfilled, (state, action) => {
      state.adminList = state.adminList.map((item) =>
        item._id === action.payload.data._id
          ? { ...item, ...action.payload.data }
          : item
      );
      state.loading = false;
    });

    builder.addCase(Act.updateAdminApi.rejected, (state) => {
      state.loading = false;
    });

    // Delete Admin
    builder.addCase(Act.deleteAdminApi.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(Act.deleteAdminApi.fulfilled, (state, action) => {
      state.adminList = state.adminList.filter(
        (item) => item._id !== action.payload.data._id
      );
      state.totalAdmin = Math.max(0, state.totalAdmin - 1);
      state.loading = false;
    });

    builder.addCase(Act.deleteAdminApi.rejected, (state) => {
      state.loading = false;
    });

    // Get Admin Details
    builder.addCase(Act.adminDetailsApi.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(Act.adminDetailsApi.fulfilled, (state, action) => {
      state.adminDetails = action.payload.data;
      state.loading = false;
    });

    builder.addCase(Act.adminDetailsApi.rejected, (state) => {
      state.loading = false;
    });

    // Change Admin Status
    builder.addCase(Act.adminStatusChangesApi.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(Act.adminStatusChangesApi.fulfilled, (state, action) => {
      state.adminList = state.adminList.map((item) =>
        item._id === action.payload.data._id
          ? { ...item, ...action.payload.data }
          : item
      );
      state.loading = false;
    });

    builder.addCase(Act.adminStatusChangesApi.rejected, (state) => {
      state.loading = false;
    });

    // Get Active Role List
    builder.addCase(Act.roleActiveListApi.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(Act.roleActiveListApi.fulfilled, (state, action) => {
      state.activeRoleList = action.payload.data;
      state.totalActiveRole = action.payload.totalcount;
      state.loading = false;
    });

    builder.addCase(Act.roleActiveListApi.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default slice;